import React from 'react';
import { V2ProductPageProps } from '../types';

export function Placeholder({ product }: V2ProductPageProps) {
  return (
    <div className="alert alert-info">
      <h5 className="alert-heading">Próximamente</h5>
      <p className="mb-0">
        El formulario V2 de
        {' '}
        <strong>{product.name}</strong>
        {' '}
        (
        <code>{product.path}</code>
        ) todavía no está implementado.
      </p>
    </div>
  );
}
